import React, { Component, useState } from 'react'
import { Select } from 'grommet'
import { AppContext } from '../libs/context'
import { monthNames } from '../libs/common'
import { FormCalendar } from 'grommet-icons'

const sortNameFn = (a, b) => (a.name > b.name ? 1 : -1)

export const SelectMonthInYear = ({ endDate, selectAction, offsetEndMonth = -1, ...props }) => {
  const sortBy = (a, b) => {
    // this will sort department by the colourOrder key value
    let oA = a.order
    let oB = b.order
    if (oA < oB) {
      return -1
    } else if (oA > oB) {
      return 1
    }
    return 0
  }

  let months = []
  const endMonth = endDate.getMonth() + offsetEndMonth

  let x = 0
  for (let i = endMonth - 11; i <= endMonth; i++) {
    const d = new Date(endDate)
    d.setMonth(i)
    const year = d.getFullYear()
    const month = d.getMonth()
    months.push({
      name: monthNames[month % 12] + ' ' + year,
      id: i,
      month: month,
      year: year,
      order: String(year) + '_' + String(month).padStart(2, '0')
    })
    x++
  }

  const [value, setValue] = useState(endMonth)
  const update = (option) => {
    setValue(option.id)
    selectAction && selectAction(option)
  }
  months.sort(sortBy)
  return (
    <Select
      size="small"
      icon={<FormCalendar />}
      labelKey="name"
      reverse
      disabledKey={'disabled'}
      valueKey={{ key: 'id', reduce: true }}
      options={months.reverse()}
      onChange={({ option }) => update(option)}
      value={value}
      {...props}
    />
  )
}
const SelectSupplierReceiverWithContext = ({ companies = {}, receivers = {}, value, ...props }) => {
  const defaultOptions = [
    { name: 'All', id: '' },
    { name: 'SELECT COMPANY', id: '_companies', disabled: true },
    ...Object.values(companies).sort(sortNameFn),
    { name: 'SELECT RECEIVER', id: '_stores', disabled: true },
    ...Object.values(receivers).sort(sortNameFn)
  ]

  const [options, setOptions] = useState(defaultOptions)
  let valueAsName = 'All'
  if (value.companyId && companies[value.companyId]) {
    valueAsName = companies[value.companyId].name
  }
  if (value.receiverId && receivers[value.receiverId]) {
    valueAsName = receivers[value.receiverId].name
  }
  return (
    <Select
      size="small"
      labelKey="name"
      disabledKey={'disabled'}
      valueKey={{ key: 'name', reduce: true }}
      options={options}
      onSearch={(value) => {
        const exp = new RegExp(value.toLowerCase(), 'i')
        setOptions(
          value ? defaultOptions.filter((o) => exp.test(o.name.toLowerCase())) : defaultOptions
        )
      }}
      value={valueAsName}
      {...props}
    />
  )
}

export const SelectSupplierReceiver = (props) => (
  <AppContext.Consumer>
    {({ companies, receivers }) => (
      <SelectSupplierReceiverWithContext receivers={receivers} companies={companies} {...props} />
    )}
  </AppContext.Consumer>
)
